export default __webpack_public_path__ + "static/media/affiche2016.3f29fbd2.png";